<script>
	import { Table } from "@sveltestrap/sveltestrap";

	export let errors;

	const resolutions = {
		"Missing start date": "Add a start date",
		"Missing end date": "Add an end date",
		"Wrong start date format": "Use “DD/MM/YYYY HH:MM”",
		"Start date and time has passed the current date and time":
			"Ensure that start date and time is after the current date and time",
		"Duplicated ‘Servicing In’ task": "Duplicated ‘Servicing In’ task",
		"Duplicated ‘Servicing Out’ task": "Duplicated ‘Servicing Out’ task",
	};
</script>

<Table>
	<thead>
		<tr>
			<th>Row</th>
			<th>Error(s)</th>
			<th>Resolution(s)</th>
		</tr>
	</thead>
	<tbody>
		{#each errors as { lineNumber, errorMessage }, i}
			<tr>
				<td>{lineNumber}</td>
				<td>{errorMessage}</td>
				<td>{resolutions[errorMessage] || ""}</td>
			</tr>
		{/each}
	</tbody>
</Table>
